/**
 * Strip inline space catalog text when structured cards are shown beneath the reply.
 */
const NUMBERED_LIST_LINE = /^\s*\d+\.\s+.+/;
const BULLET_LINE = /^\s*[-•*]\s+.+/;
const MARKDOWN_LINK_LINE = /^\s*\[[^\]]+\]\([^)]+\)\s*$/;
const MARKDOWN_IMAGE_LINK_LINE = /^\s*!\[[^\]]+\]\([^)]+\)\s*$/;
const SPACE_DETAIL_BULLET = /^\s*[-•*]\s*(address|price|capacity|amenities|location|links?)\s*:/i;
const BOLD_TITLE_ONLY = /^\s*\*\*[^*]+\*\*\s*$/;
const BOOK_OR_IMAGE = /(\[book here\]|\[book\]\(|!\[?image\]?)/i;
const BOOKING_PAGE_URL = /\/space\/bookings/i;

const DEFAULT_INTRO = 'Here are some options that might work for you.';

const isListingLine = (line) => {
  const trimmed = (line || '').trim();
  if (!trimmed) return false;
  if (BOOKING_PAGE_URL.test(trimmed)) return false;
  if (NUMBERED_LIST_LINE.test(trimmed)) return true;
  if (BULLET_LINE.test(trimmed)) return true;
  if (MARKDOWN_LINK_LINE.test(trimmed)) return true;
  if (MARKDOWN_IMAGE_LINK_LINE.test(trimmed)) return true;
  if (SPACE_DETAIL_BULLET.test(trimmed)) return true;
  if (BOLD_TITLE_ONLY.test(trimmed)) return true;
  if (BOOK_OR_IMAGE.test(trimmed)) return true;
  const lower = trimmed.toLowerCase();
  return lower.startsWith('address:')
    || lower.startsWith('price:')
    || lower.startsWith('capacity:')
    || lower.startsWith('amenities:');
};

export const stripSpaceListingFromReply = (reply) => {
  if (!reply || !reply.trim()) return reply;

  const lines = reply.split('\n');
  const kept = [];
  let skippingBlock = false;

  for (const line of lines) {
    if (isListingLine(line)) {
      skippingBlock = true;
      continue;
    }
    if (skippingBlock && !line.trim()) continue;
    skippingBlock = false;
    kept.push(line);
  }

  const result = kept.join('\n').trim().replace(/\n{3,}/g, '\n\n');
  return result || DEFAULT_INTRO;
};

export const replyTextForMessage = (msg) => {
  if (msg?.bookingUrl) {
    return msg?.text || '';
  }
  // Empty search: the v2-search-meta panel shows the market-scoped message + actions.
  if (msg?.searchMeta?.type === 'empty' && msg.searchMeta.message) {
    return '';
  }
  if (msg?.spaces?.length > 0 && msg.text) {
    return stripSpaceListingFromReply(msg.text);
  }
  return msg?.text || '';
};
